import quotes from './quotation.svg'

function Testimonal() {
    return (
        <div className="w-full mx-auto px-12 py-10 text-white text-sm">
            <div className="flex flex-row space-x-4 justify-center items-center">
                <div className="bg-gray-50 p-12 space-y-8 text-black w-6/12">
                    <img src={quotes} className='w-6 h-6' alt='quotes'></img>
                    <h5 className="text-sm font-sans text-justify">
                        Jibu Labs is simply amazing. Their team is highly skilled and knowledgeable, delivering exceptional results with ease. They brought our vision to life with an incredible website design and social media strategy. We couldn't have asked for a better partner to help us achieve our digital goals.
                    </h5>
                    <div className='space-y-2'>
                        <h6 className="font-base">
                            Vice President
                        </h6>
                        <h6 className="font-semibold">
                            Mailchimp
                        </h6>
                    </div>
                    <div className='flex flex-row space-x-4'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="w-6 h-6 cursor-pointer">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="w-6 h-6 cursor-pointer">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                        </svg>
                    </div>
                </div>

                <div className="w-6/12 px-20 space-y-4">
                    <div className="flex flex-row items-center space-x-2">
                        <span className="bg-white inline-block h-1 w-1 rounded-full"></span>
                        <span className="block mt-4 lg:inline-block lg:mt-0 text-white mr-4 uppercase font-sans text-xs">Success Stories</span>
                    </div>
                    
                    <h2 className="text-orange-500 text-9xl font-semibold flex-grow">
                        12+
                    </h2>

                    <h4 className="text-2xl font-base">
                        Completed Projects
                    </h4>

                    <p className="font-light text-sm text-justify">
                        At Jibu Labs, we are proud of our track record of helping organizations scale intelligent solutions. Our advanced AI capability engineering and strategic approach make us a reliable partner for your most critical digital transformations.
                    </p>
                    
                </div>
        
            </div>
        </div>
    )
}

export default Testimonal